import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  storageLimit: "",
  storageLimitExceeded: false,
  storageRemaining: "",
  storageUsed: "",
  storageUsedPercentage: "",
  audios: { data: [] },
  documents: { data: [] },
  images: { data: [] },
  wheels: { data: [] },
  videos: { data: [] },
  audiosStorage: "",
  documentsStorage: "",
  imagesStorage: "",
  wheelsStorage: "",
  videosStorage: "",
};

const storageSlice = createSlice({
  name: "hotbar",
  initialState,
  reducers: {
    setStorage: (state, action) => {
      state.storageLimit = action.payload.storage_limit;
      state.storageLimitExceeded = action.payload.storage_limit_exceeded;
      state.storageRemaining = action.payload.storage_remaining;
      state.storageUsed = action.payload.storage_used;
      state.storageUsedPercentage = action.payload.storage_used_percentage;
      state.audiosStorage = action.payload.storage_by_type.audios;
      state.imagesStorage = action.payload.storage_by_type.images;
      state.videosStorage = action.payload.storage_by_type.audios;
      state.documentsStorage = action.payload.storage_by_type.audios;
      state.wheelsStorage = action.payload.storage_by_type.others;


    },
    setVideos: (state, action) => {
      state.videos = action.payload;
    },
    setImages: (state, action) => {
      state.images = action.payload;
    },
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    setAudios: (state, action) => {
      state.audios = action.payload;
    },
    setWheels: (state, action) => {
      state.wheels = action.payload;
    },
  },
});

export const { setStorage, setVideos, setImages, setDocuments, setAudios, setWheels } =
  storageSlice.actions;

export default storageSlice.reducer;
